import { useMemo } from 'react';
import { useUserInfo } from './useUserInfo';
export const useUserHasScopes = scopes => {
  const userInfo = useUserInfo();
  const userScopes = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.scopes;
  const hasScopes = useMemo(() => {
    const userInfoScopes = userScopes ? new Set(userScopes) : new Set();
    return scopes.every(scope => userInfoScopes.has(scope));
  }, [userScopes, scopes]);
  return hasScopes;
};